import script from "./Approvals.vue?vue&type=script&setup=true&lang=js"
export * from "./Approvals.vue?vue&type=script&setup=true&lang=js"

import "./Approvals.vue?vue&type=style&index=0&id=75488033&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75488033"]])

export default __exports__